import DOMPurify from 'dompurify';

const sanitizeRichTextHtml = (html: string) =>
  DOMPurify.sanitize(html, {
    ADD_ATTR: ['target'],
  });

export default sanitizeRichTextHtml;
